import { render, staticRenderFns } from "./TopMenuBarGuest.vue?vue&type=template&id=495ca870&scoped=true&"
import script from "./TopMenuBarGuest.vue?vue&type=script&lang=js&"
export * from "./TopMenuBarGuest.vue?vue&type=script&lang=js&"
import style0 from "./TopMenuBarGuest.vue?vue&type=style&index=0&id=495ca870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ca870",
  null
  
)

export default component.exports